import config from '@/config';
import widgetSettings from '@/widget-settings';
import { createI18n } from 'vue-i18n';
import en from './translations/en.json';

const defaultLocale = config.LANGUAGES.includes(widgetSettings.language)
  ? widgetSettings.language
  : 'en';

const dateTimeFormat = {
  weekday: {
    weekday: 'short'
  },
  weekdayLong: {
    weekday: 'long'
  },
  day: {
    day: 'numeric'
  },
  month: {
    month: 'short'
  },
  monthLong: {
    month: 'long',
    year: 'numeric'
  },
  monthDay: {
    month: 'long',
    day: 'numeric'
  },
  full: {
    weekday: 'long',
    day: 'numeric',
    month: 'short'
  },
  time: {
    hour: 'numeric',
    minute: 'numeric',
    hour12: false
  }
};

const currencyFormat = {
  style: 'currency',
  currency: 'EUR'
};

const messages = {};
const datetimeFormats = {};
const numberFormats = {};

if (config.isTest) {
  ['en', 'nl'].forEach((locale) => {
    messages[locale] = en;
    datetimeFormats[locale] = dateTimeFormat;
    numberFormats[locale] = { currency: currencyFormat };
  });
} else {
  const modules = import.meta.glob('./translations/*.json', {
    eager: true
  });

  config.LANGUAGES.forEach((locale) => {
    const mod = modules[`./translations/${locale}.json`];
    if (mod) {
      messages[locale] = mod;
      datetimeFormats[locale] = dateTimeFormat;
      numberFormats[locale] = { currency: currencyFormat };
    }
  });
}

export const i18n = createI18n({
  locale: defaultLocale,
  messages,
  datetimeFormats,
  numberFormats,
  silentTranslationWarn: config.isDevelopment,
  legacy: false
});

export default i18n.global;
